import { Component, Inject, InjectionToken, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {} from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessagingService } from './services/messaging.service';
import 'zone.js';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { assets } from './core/constants/assets.const';

@Component({
  selector: 'mindbase-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    TranslateModule,
    NgxUiLoaderModule
  ],
  providers: [TranslateService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'mindbase';

  constructor(
    public translate: TranslateService,
    private _messagingService: MessagingService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: InjectionToken<object>
  ) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._messagingService.requestPermission();
      this._messagingService.listenForFrontMessages();
      this.translate.get('notificationAlert').subscribe(() => {
        if (Notification.permission === 'denied') {
          alert(this.translate.instant('Please enable browser notifications to receive important updates.'));
        } 
      });
    }

        
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.action === 'navigate') {
        window.location.href = event.data.url;
      }  else if (event.data && event.data.action === 'playNotificationSound') {
        this.playNotificationSound();
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        document.body.scrollTop = 0;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      }
    });
  }

  private playNotificationSound(): void {
    const audio = new Audio(assets.notificationSound); // Adjust path as needed
    audio.play().catch((error) => {
      console.error('Error playing notification sound:', error);
    });
  }

}
